import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "studio-page-intro",
  class: "tw-mb-10 tw-gap-10 tw-pt-2"
}
const _hoisted_2 = { class: "tw-mb-2 tw-text-xl tw-font-medium tw-leading-tight tw-tracking-tight tw-text-black dark:tw-text-white" }
const _hoisted_3 = { class: "tw-max-w-xl tw-pt-2 tw-text-sm tw-text-black dark:tw-text-white lg:tw-pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}